import { render } from "./quickstarsOrder.vue?vue&type=template&id=50dfda8c&scoped=true"
import script from "./quickstarsOrder.vue?vue&type=script&lang=js"
export * from "./quickstarsOrder.vue?vue&type=script&lang=js"

import "./quickstarsOrder.vue?vue&type=style&index=0&id=50dfda8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50dfda8c"]])

export default __exports__